import { useDispatch, useSelector } from 'react-redux'
import { IconButton, TableHead, TableRow, TableCell } from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

import { colours } from '../settings/settings'
import { setSorting } from '../container/sorting'

const SortableTableHead = ({ table, setTable, columns, tableName }) => {
  const sortingColumn = useSelector(state => state.sorting[tableName]?.column)
  const sortingAscending = useSelector(
    state => state.sorting[tableName]?.ascending,
  )

  const dispatch = useDispatch()

  const sDispatch = (column, ascending) =>
    dispatch(setSorting({ table: tableName, column, ascending }))

  const sortByField = (a, b, c) =>
    a[c] === undefined
      ? 1
      : b[c] === undefined
        ? -1
        : a[c] === b[c]
          ? 0
          : a[c] > b[c]
            ? !sortingAscending
              ? 1
              : -1
            : !sortingAscending
              ? -1
              : 1

  return (
    <TableHead style={{ backgroundColor: colours.greyVeryLight }}>
      <TableRow>
        {columns.map((column, index) => (
          <TableCell key={index}>
            {(column.sortable && (
              <>
                <IconButton
                  size='small'
                  disabled
                  style={{ color: 'transparent' }}
                >
                  <ArrowDownwardIcon />
                </IconButton>
                &nbsp;
                <b style={{ color: colours.greyVeryDark }}>{column.label}</b>
                &nbsp;
                <IconButton
                  size='small'
                  style={{
                    color:
                      !!sortingColumn && sortingColumn === column.sortingField
                        ? colours.greyVeryDark
                        : colours.greyLight,
                  }}
                  onClick={() => {
                    if (
                      !!sortingColumn &&
                      sortingColumn === column.sortingField
                    ) {
                      sDispatch(column.sortingField, !sortingAscending)
                      if (setTable)
                        setTable(
                          table.sort((a, b) =>
                            sortByField(a, b, column.sortingField),
                          ),
                        )
                    } else {
                      sDispatch(column.sortingField, true)
                      if (setTable)
                        setTable(
                          table.sort((a, b) =>
                            sortByField(a, b, column.sortingField),
                          ),
                        )
                    }
                  }}
                >
                  {(!!sortingColumn &&
                    sortingColumn === column.sortingField &&
                    !sortingAscending && <ArrowUpwardIcon />) || (
                    <ArrowDownwardIcon />
                  )}
                </IconButton>
              </>
            )) || <b style={{ color: colours.greyVeryDark }}>{column.label}</b>}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default SortableTableHead
